import { render, staticRenderFns } from "./QuestionOverview.vue?vue&type=template&id=8006501e&scoped=true&"
import script from "./QuestionOverview.vue?vue&type=script&lang=ts&"
export * from "./QuestionOverview.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionOverview.vue?vue&type=style&index=0&id=8006501e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8006501e",
  null
  
)

export default component.exports